import Gumshoe from 'gumshoejs'
import axios from 'axios'
import swal from 'sweetalert'
import Pikaday from 'pikaday'

const headerDom = document.querySelector('header')
const contentDom = document.querySelector('.main')
const htmlDom = document.querySelector('html')
const hamburgerMenuClick = document.querySelector('.mobile-hamburger')
const headerMenu = document.querySelector('.main-menu')
const headerMenuList = document.querySelectorAll('.main-menu li')

const appForm = document.querySelectorAll('.appForm')

hamburgerMenuClick.addEventListener('click', () => {
  headerMenu.classList.add('header-menu--show')
  htmlDom.classList.add('no-scroll')
})

headerMenuList.forEach((list) => {
  list.addEventListener('click', () => {
    headerMenu.classList.remove('header-menu--show')
    htmlDom.classList.remove('no-scroll')
  })
})


function headerScroll() {
  const wScroll = window.scrollY
  if (wScroll > 40) {
    headerDom.classList.add('header--scroll')
  } else {
    headerDom.classList.remove('header--scroll')
  }
}

headerScroll()

window.addEventListener('scroll', headerScroll)

window.onload = () => {
  contentDom.style.marginTop = `${headerDom.offsetHeight}px`
}

const serialize = (formEl) => {
  const formData = [];
  for (let i = 0; i < formEl.elements.length; i++) {
    const field = formEl.elements[i];
    if (field.name && !field.disabled && field.type !== 'button' && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit') {
      if (field.type === 'checkbox' && !field.checked) {
        continue
      }
      formData[formData.length] = `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`;
    }
  }
  return formData.join('&').replace(/%20/g, '+');
};

function setInputFilter(textbox, inputFilter) {
  ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
    textbox.addEventListener(event, function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      /*  eslint no-prototype-builtins: ["off"] */
      } else if (this.hasOwnProperty('oldValue')) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  });
}

document.querySelectorAll('.input__number-only').forEach((input) => {
  setInputFilter(input, function (value) {
    return /^\d*\.?\d*$/.test(value);
  });
});

function download(url, name) {
  const shadowLinkTag = document.createElement('a');
  shadowLinkTag.href = url;
  shadowLinkTag.download = name;
  shadowLinkTag.click();
}

// const spy = new Gumshoe('#mainNav a', {
//   reflow: true,
//   offset() {
//     return headerDom.getBoundingClientRect().height
//   }
// })

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    })
  })
})


appForm.forEach((form) => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const data = serialize(this);
    const btnSubmit = this.querySelector('[type="submit"]');
    const btnText = btnSubmit.textContent;
    btnSubmit.setAttribute('disabled', 'true');
    btnSubmit.textContent = 'Submitting...';

    axios.post('https://predictable-hci.com/form-entry-storage.php', data)
      .then((res) => {
        if (res.data.success) {
          swal('Terima kasih', 'Data sukses terkirim', 'success')
        } else {
          swal('Opps', res.data.message, 'error');
        }

        grecaptcha.reset(widgetId1);
        // grecaptcha.reset(widgetId2);
        this.reset();
      })
      .catch((err) => {
        swal('Opps', 'We are under maintenance', 'error');
        console.log(err);
      })
      .finally(() => {
        btnSubmit.removeAttribute('disabled');
        btnSubmit.textContent = btnText;
      });
  })
})